/* 🤖 this file was generated by svg-to-ts */
export const prizmIconsTv: {
  name: 'tv';
  data: string;
} = {
  name: 'tv',
  data: `<svg fill="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path fill-rule="evenodd" clip-rule="evenodd" d="M8.707 2.293a1 1 0 0 0-1.414 1.414L9.586 6H5a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2V8a2 2 0 0 0-2-2h-4.586l2.293-2.293a1 1 0 0 0-1.414-1.414L12 5.586 8.707 2.293ZM5 20V8h14v12H5Z" fill="currentColor"/></svg>`,
};
